import Turbolinks from 'turbolinks'

;(function () {
  let scrollPosition
  let notice

  document.addEventListener('turbolinks:load', function () {
    if (notice) {
      window?.app?.notify(notice.title ?? notice, {text: notice.text, type: 'success'})
      notice = undefined
    }

    if (scrollPosition) {
      if (window.location.pathname.startsWith('/admin')) {
        const adminContent = document.querySelector('.tfx-admin-body')
        if (adminContent) {
          adminContent.scrollLeft = scrollPosition[0]
          adminContent.scrollTop = scrollPosition[1]
        }
      } else {
        window.scrollTo(...scrollPosition)
      }
      scrollPosition = null
    }
  }, false)


  Turbolinks.reloadWithNotice = function (text) {
    notice = text
    this.reload()
  }

  Turbolinks.visitWithNotice = function (url, text, options) {
    notice = text
    this.visit(url, options)
  }

  Turbolinks.reload = function () {
    if (window.location.pathname.startsWith('/admin')) {
      const adminContent = document.querySelector('.tfx-admin-body')
      if (adminContent) {
        scrollPosition = [adminContent.scrollLeft, adminContent.scrollTop]
      }
    } else {
      scrollPosition = [window.scrollX, window.scrollY]
    }
    Turbolinks.visit(window.location, {action: 'replace'})
  }
})()
